import { render } from "./DashboardOverview.vue?vue&type=template&id=38cd7678&scoped=true&ts=true"
import script from "./DashboardOverview.vue?vue&type=script&lang=ts"
export * from "./DashboardOverview.vue?vue&type=script&lang=ts"

import "./DashboardOverview.vue?vue&type=style&index=0&id=38cd7678&scoped=true&lang=css"

import exportComponent from "/Users/mufeng/Documents/ProjectWorkbench/hotaru_theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cd7678"]])

export default __exports__